import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useGlobalContext } from '../hooks';

export function RequireAuth({ children }: { children: JSX.Element }) {
  let location = useLocation();
  const { isLoggedIn, userDetails } = useGlobalContext();

  if (!isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  } else {
    return children;
  }
}